const SettingsNone = () => {
  return <div className="w-full border-l flex items-center justify-center p-8 text-systemGray-300">Nothing is selected.</div>;
};

export default SettingsNone;
